import React, { useEffect, useRef, useState } from "react";
import editInput from "../../../helpers/Inputs/editInput";
import safeUpdateFunction from "../../../helpers/Inputs/safeUpdateFunction";

import "../../../assets/css/inputs/input-main.css";
import "../../../assets/css/inputs/inputPasswordComp.css";


const InputPasswordComp = ({name, className, eyeClassName, id, metaData, onChange, value, updateFunction, field, maxLength, minLength, required, readonly, placeholder, form, pattern, autocomplete}) => {
     // How to use
    /*
        name - string
        className - string
        id - string
        metaData - object
        onChange - fn
        value - string
        updateFunction - fn
        field - string
        maxLength - num
        minLength - num
        required - bool
        readOnly - bool
        placeholder - string
        form - string
        pattern - pattern
        autocomplete - bool
    */

    const [currentValue, setCurrentValue] = useState(value || "");
    const [passwordView, setPasswordView] = useState(false);
    const firstRender = useRef(true);

    useEffect(() => {
        if(!value) {
            safeUpdateFunction(null, currentValue, updateFunction, field);
        }

        if(firstRender.current){
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if(!firstRender.current) {
            if(typeof value === "string" && currentValue !== value) {
                setCurrentValue(value);
            }
        }
    }, [value])
    
    return (
        <>
            <div className={"flex flexCenter inputPasswordComp-container "}>
                <input 
                    type={passwordView ? "text" : "password"} 
                    name={name || ""} 
                    id={id || ""}  
                    {...metaData || undefined}
                    onChange={(e) => {
                        editInput(e, onChange, field, updateFunction, setCurrentValue);
                    }}
                    value={currentValue || ""}
                    className={"input-base inputPasswordComp-input " + (className || "")}
                    maxLength={maxLength || undefined}
                    minLength={minLength || undefined}
                    required={required || false}
                    readOnly={readonly || false}
                    placeholder={placeholder || ""}
                    form={form || ""}
                    pattern={pattern || undefined}
                    autocomplete={autocomplete || false}
                />
                <i className={"passwordToggleText fa-solid "  + (passwordView ? "fa-eye " : "fa-eye-slash ") + (eyeClassName || "")}
                    onClick={() => setPasswordView((prev) => !prev)}
                />
                    {/* className={"userInfoEditEye " + (passwordView ? "fa-eye" : "fa-eye-slash")}  */}
                {/* </i> */}
            </div>
        </>
    );
};

export default InputPasswordComp;